export default __webpack_public_path__ + "static/media/76.79cb1652.png";